export default __webpack_public_path__ + "static/media/logout.14a9522b.svg";